
import { defineComponent, watch } from 'vue'
import type { PropType } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import store from '@/store'
import Multiselect from 'vue-multiselect'

export default defineComponent({
  components: {
    Multiselect
  },
  props: {
    pageOptions: {
      type: Array as PropType<number[]>,
      default: () => [25, 50, 100]
    }
  },
  emits: ['selected'],
  setup(props, { emit }) {
    const { useActions } = createNamespacedHelpers('pagination')
    const { updatePage } = useActions(['updatePage'])

    watch(
      () => store.state.pagination.perPage,
      () => {
        updatePage(1)
        emit('selected')
      }
    )

    return { store }
  }
})
